/* eslint-disable prefer-template */

const constants = {
  organizationName: "Tiger Analytics",
};

export const DEFAULT_DOMAIN = "cpg";

export const fxCode = '';// `?code=UAetwHXbmRRj3alj0Fs-WxnWFylk8KpTd1qBRkHWAfekAzFuhwQ5jw==`;


export const ENDPOINTS = {
  Login: "login" + fxCode,
  updateUserConfig: "update_user_config" + fxCode,
  generateReport: "report_generate" + fxCode,
  chatHistory: "chat_history" + fxCode,
  chatFeedback: "chat_feedback" + fxCode,
  preTrack: "conv_layer" + fxCode,
  track1: "text_to_query" + fxCode,
  track2: "query_to_chart" + fxCode,
  track3: "table_to_insights" + fxCode,
  knowledgeBase: "knowledge_base" + fxCode,
  postTrack: "post_track" + fxCode,
  conversationSummary: "chat_session_history" + fxCode,
  domainNames: "get_domain_names" + fxCode,
  routerAgent: "router_agent" + fxCode,
  deleteChat: "delete_chat" + fxCode,
  renameChatTitle: "rename_chat" + fxCode,
  managerAgent: "manager_agent" + fxCode,
  pythonDataAgent: "python_data_agent" + fxCode,
  pythonModellingAgent: "python_modelling_agent" + fxCode,
  sqlAgent: "sql_agent" + fxCode,
  plotAgent: "plot_agent" + fxCode,
  insightsAgent: "insights_agent" + fxCode,
  summarizerAgent: "summarizer_agent" + fxCode,
  stream_data_test: "insights_agents" + fxCode,
  downloadReport: "download_admin_report" + fxCode,
  accountInfo: "get_user_account_info" + fxCode,
  getShareUsers: "get_share_thread_users" + fxCode,
  getUsersList: "get_user_details" + fxCode,
  shareChat: "share_chat" + fxCode,
  newsFeedLatest: "news_feed/latest" + fxCode,
  topicDetails: "get_topics",
  fetchMetricDetails: "fetch_metrics",
  getFilters: "fetch_filters",
  fetchChartDetails: "fetch_chart_data",
  getEventFilters: "get_event_filters",
  eventDetails: "get_events",
  fetchInsights: "fetch_insights",
  fetchLatestDate: "latest_household_period",
  deleteUser: "delete_user" + fxCode
};


export const categories: any = {
  "cost management": [
    "How many branches do we have?",
    "Which region have the most branches?",
    "Show me the top 5 branches with highest revenue",
    "How big the difference between the 5 top branches and 5 lowest branches?"
  ],
  "credit": [
    "Which reason has caused the most number of issues over the years?",
    "Give a breakdown of issue according the their method of identification",
    "Can you show the distribution of open issues by risk rating?",
    "Show open issues, closed issues and net issues trend month on month?"
  ],
  "finance": [
    "What is the total number of consumers and the total trades taken till date?",
    "What is the percentage of installment trades with good and bad risk estimate?",
    "How many bad consumers have a revolving burden on their trades that exceeds 50%?",
    "Which consumers have >50% of trades as installment and has never been delinquent"
  ],
  "insurance": [
    "What is the average number of active members within the medical insurance plan for the year 2022?",
    "What are the number of active members within different insurance services",
    "What is the top major cost for different line of businesses in 2022?",
    "What is the total paid amount for each line of business?"
  ],
  "cpg": [
    "What are the top PPGs based on the value sales data available?",
    "Which PPGs drove 80% of total sales in 2023?",
    "Which retailer has the highest market share in the year 2023?",
    "Calculate the market shares of all Brands for 2023"
  ],
  "it service management": [
    "Who are the top 5 individuals who raised the most incidents?",
    "What is the distribution of incident states in the dataset?",
    "What is the distribution of incident priorities in the dataset?",
    "How often are incidents updated by different individuals?"
  ],
  "marketing": [
    "What is the return on investment (ROI) for the marketing activities?",
    "What brands are the biggest drainers and drivers of the change in revenue?",
    "What is the portfolio distribution across categories?",
    "What is the monthly trend of average product price?"
  ],
  "manufacturing": [
    "Give me the names of all process paramaters",
    "Give me the mean values of process parameter by equipments",
    "What is the average value of excitation current?",
    "What is the ID for process paramater named Temperature?"
  ],
  "medical r and d": [
    "What’s the average number of publications each archetype has?",
    "How many HCPs on average have non-zero publications within each archetype?",
    "Give me the list of Pharma_Ehs companies along with the count of HCPs who prefer them",
    "Show me the top 5 HCPs with whom an MSL has met F2F or Virtual and who also have at least 5 publications"
  ],
  "healthcare": [
    "What is the Total number/Unique Count of Client and Caregivers by each Practice?",
    "How many caregivers has served across multiple Practice",
    "What is the count of caregiver willing to work in the Night Shift by each Practice?",
    "What is the total number of service days provided by caregivers?"
  ],
  "mcd": [
    "What are the top 10 selling items in my store 84000047 in the current round?",
    "What is the actual margin impact of item 5 in store 84000047 for each channel in the previous round?",
    "What is the sensitivity of item 1 in store 84000047 for each channel in the latest round?",
    "What is the estimated margin impact of price changes in store 84000047 for each channel in the current round?"
  ],
  "supply chain management": [
    "What is the on-time status for all shipments from Location 21?",
    "Name all the carriers that shipped the cheese flavor?",
    "How many trips are inbound to Location 10?",
    "What is the average order to delivery time for cheese flavor?"
  ],
  "pharma rxrep": [
    "How many sales reps are detailing for Tagrisso in USA?",
    "How many calls were made by Tagrisso sales reps in past 12 months?",
    "What is the brand market shares in the USA for lung cancer in the last 1 year",
    "What is Tagrisso’s market share for lung cancer in USA in the last 1 year"
  ],
  "hr": [
    "In 2024, which practices received the most applications?",
    "What is the distribution of application status by practice in 2024?",
    "Give me the count of Interviews scheduled by month in 2024",
    "For every practice show me the office-level rejection rate in 2024?"
  ],
  "marketing insights": [
    "What is the longest running campaign",
    "Which campaign spent the most on females",
    "What is the overall spent and revenue generated",
    "What is the overall roi for paid ads campaign_type"
  ],
  "sales": [
    "What is the sales in dollars of listerine in 2024 within pos data, quaterly?",
    "Which brand sold the most this year by units, yearly for shipment data?",
    "Compare the total sales and units for TYLENOL for year 2024 vs 2023 in shipment data?",
    "What is the market share for Kenvue mouthwash in June 2023?"
  ],
  "employee expense mgmt": [
    "What is the total flight spend for domestic flights in 2024?",
    "What is the average spend per invoice for international flights in 2024?",
    "What is the total travel spend on economy class flights for the year 2024?",
    "What is the total number of distinct bookings for flights in 2024?"
  ],
  "retail customer behavior": [
    "Which household has the highest total spend?",
    "What is the average spend per visit across different age groups?",
    "What is the average number of customer visits per week?",
    "What is the average basket size per transaction?"
  ],
  "retail sales and pricing": [
    "What were last week’s net sales at site 10024711?",
    "Show me the top-selling product at 10024711 in July?",
    "Which top 5 sub-categories sold the most last week?",
    "How many sites had markdowns last week?"
  ]
}
export default constants;
